(function () {
  var carouselSelector = "[data-best-sellers-carousel]";
  var initializedAttribute = "data-best-sellers-initialized";
  var stateMap = new WeakMap();

  function isMobileMode() {
    return !window.matchMedia("(min-width: 768px)").matches;
  }

  function getStep() {
    if (window.matchMedia("(min-width: 1000px)").matches) {
      return 5;
    }

    return 3;
  }

  function getDirection() {
    return window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.direction === "rtl" ? -1 : 1;
  }

  function getTrack(carousel) {
    return carousel.querySelector(".best-sellers__track");
  }

  function getViewport(carousel) {
    return carousel.querySelector(".scroller");
  }

  function getControls(carousel) {
    return {
      prev: carousel.querySelector("[data-best-sellers-prev]"),
      next: carousel.querySelector("[data-best-sellers-next]")
    };
  }

  function getPageCount(track, step) {
    return Math.max(1, Math.ceil(track.children.length / step));
  }

  function getStartIndex(track, step, page) {
    var maxStartIndex = Math.max(0, track.children.length - step);
    return Math.min(page * step, maxStartIndex);
  }

  function getPageOffset(track, viewport, step, page) {
    var firstCard = track.children[0];
    var targetCard = track.children[getStartIndex(track, step, page)];

    if (!firstCard || !targetCard) {
      return 0;
    }

    var distance = Math.abs(targetCard.getBoundingClientRect().left - firstCard.getBoundingClientRect().left);
    var maxOffset = Math.max(0, track.scrollWidth - viewport.clientWidth);

    return Math.min(distance, maxOffset);
  }

  function setInstant(track, instant) {
    track.classList.toggle("is-best-sellers-instant", instant);
  }

  function applyTransform(track, offset) {
    track.style.setProperty("--best-sellers-offset", offset * getDirection() * -1 + "px");
  }

  function updateButtons(carousel) {
    var state = stateMap.get(carousel);
    var controls = getControls(carousel);

    if (!state || !controls.prev || !controls.next) {
      return;
    }

    if (isMobileMode()) {
      controls.prev.disabled = true;
      controls.next.disabled = true;
      return;
    }

    controls.prev.disabled = state.isAnimating || state.currentPage <= 0;
    controls.next.disabled = state.isAnimating || state.currentPage >= state.pageCount - 1;
  }

  function syncCarousel(carousel, options) {
    var state = stateMap.get(carousel);
    var track = getTrack(carousel);
    var viewport = getViewport(carousel);

    if (!state || !track || !viewport) {
      return;
    }

    if (isMobileMode()) {
      state.currentPage = 0;
      state.pageCount = 1;
      state.isAnimating = false;
      setInstant(track, true);
      applyTransform(track, 0);
      window.requestAnimationFrame(function () {
        setInstant(track, false);
      });
      updateButtons(carousel);
      return;
    }

    var step = getStep();
    state.step = step;
    state.pageCount = getPageCount(track, step);
    state.currentPage = Math.min(state.currentPage, state.pageCount - 1);
    track.scrollLeft = 0;

    if (options && options.instant) {
      setInstant(track, true);
    }

    applyTransform(track, getPageOffset(track, viewport, step, state.currentPage));

    if (options && options.instant) {
      window.requestAnimationFrame(function () {
        setInstant(track, false);
      });
    }

    updateButtons(carousel);
  }

  function unlockAfterTransition(carousel) {
    var state = stateMap.get(carousel);
    var track = getTrack(carousel);

    if (!state || !track) {
      return;
    }

    var unlocked = false;

    function unlock() {
      if (unlocked) {
        return;
      }

      unlocked = true;
      window.clearTimeout(state.unlockTimer);
      state.isAnimating = false;
      updateButtons(carousel);
    }

    track.addEventListener("transitionend", function (event) {
      if (event.target === track && event.propertyName === "transform") {
        unlock();
      }
    }, { once: true });

    state.unlockTimer = window.setTimeout(unlock, 1300);
  }

  function move(carousel, direction) {
    var state = stateMap.get(carousel);

    if (!state || state.isAnimating || isMobileMode()) {
      return;
    }

    var nextPage = Math.max(0, Math.min(state.currentPage + direction, state.pageCount - 1));

    if (nextPage === state.currentPage) {
      updateButtons(carousel);
      return;
    }

    state.currentPage = nextPage;
    state.isAnimating = true;
    updateButtons(carousel);
    syncCarousel(carousel);
    unlockAfterTransition(carousel);
  }

  function initCarousel(carousel) {
    if (carousel.hasAttribute(initializedAttribute)) {
      return;
    }

    var track = getTrack(carousel);
    var controls = getControls(carousel);

    if (!track || !controls.prev || !controls.next) {
      return;
    }

    carousel.setAttribute(initializedAttribute, "true");
    stateMap.set(carousel, {
      currentPage: 0,
      isAnimating: false,
      pageCount: 1,
      resizeTimer: null,
      step: getStep(),
      unlockTimer: null
    });

    controls.prev.addEventListener("click", function () {
      move(carousel, -1);
    });

    controls.next.addEventListener("click", function () {
      move(carousel, 1);
    });

    window.addEventListener("resize", function () {
      var state = stateMap.get(carousel);

      if (!state) {
        return;
      }

      window.clearTimeout(state.resizeTimer);
      state.resizeTimer = window.setTimeout(function () {
        syncCarousel(carousel, { instant: true });
      }, 120);
    });

    syncCarousel(carousel, { instant: true });
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll(carouselSelector), initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
